module.exports = __webpack_public_path__ + "static/media/Results_Glyph_CaseStudy.53c0af4a.png";